// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"DX-z","inlineTitle":"EX-z","sponsoredAdsWrapper":"FX-z","marketplaceRecosWrapper":"GX-z"};